import Header from "../components/header.jsx";
import Sidebar from "../components/sidebar.jsx";
import EmployeeSalary from "../components/employeeSalary.jsx";
import Footer from "../components/footer.jsx";

function EmployeeSalarypage() {
    return (
        <div>
        <div className='wrapper'>
          <Header />
          <Sidebar /> 
          <EmployeeSalary/> 
        </div>
        <Footer /> 
      </div>
      // <Login/>
      );
}
export default EmployeeSalarypage;
